import React from 'react'

import { func, number } from 'prop-types'

import { formatCountdown } from 'Pods/Shared/Hooks/useResendCountdown'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function Resend({ secondsLeft, onResend }) {
  const t = useTranslation()

  return (
    <p className="ai-sign-in-modal__resend cgt-body-base">
      {t('signIn.code.resendPrompt')}
      {' '}
      {secondsLeft > 0 ? (
        <span className="ai-sign-in-modal__resend-countdown">
          {/* The countdown reuses the identical AuthModal rails key instead of
              adding a parallel three-d-studio entry. */}
          {t('auth_modal.code.resend_countdown', { ns: 'rails', time: formatCountdown(secondsLeft) })}
        </span>
      ) : (
        <button
          type="button"
          className="ai-sign-in-modal__switch-link cgt-link-primary-accented"
          onClick={onResend}
        >
          {t('signIn.code.resendAction')}
        </button>
      )}
    </p>
  )
}

Resend.propTypes = {
  secondsLeft: number.isRequired,
  onResend: func.isRequired,
}

export default Resend
